module.exports = __webpack_public_path__ + "static/media/no_content.7d581298.png";